<template>
    <div>
        <div class="form-group" v-if="contextStatus !== contextPostClassStatusExpired">
            <label for="adsType">
                <slot name="ads-type-label"></slot>
            </label>
            <select v-model="query.type" class="browser-default custom-select" id="adsType">
                <slot name="ads-type-options"></slot>
            </select>
        </div>
        <div class="mb-3" v-if="isMultiProfile && profiles.length > 0">
            <profile-select
                :label-title="i18n.profileSelectLabel"
                :mandatory="false"
                :init-profile-id="initProfileId"
                :required="false"
                :profiles="profiles"
                :placeholder="i18n.profileSelectPlaceholder"
                @change="handleQueryUpdate"
                :modal-title="i18n.modalTitle"
                :disabled="false">
            </profile-select>
        </div>
        <!-- filters -->
        <div class="card">
            <div class="card-header bg-white" role="tab" id="filtersHeading">
              <a class="collapsed" data-toggle="collapse" href="#collapseFilters" aria-expanded="false" aria-controls="collapseFilters">
                <h6 class="mb-0">
                  <i class="fa fa-list pr-1" aria-hidden="true"></i>
                  <slot name="open-filters"></slot>
                  <i class="fa fa-chevron-right pull-right"></i>
                </h6>
              </a>
              <p class="small mt-2" v-if="filters !== 0">
                <slot name="filters-label"></slot>
                <span>({{filters}})</span>
                <a v-if="$slots['clear-all']" @click="clearAll">
                  <slot name="clear-all"></slot>
                </a>
              </p>
            </div>

            <div id="collapseFilters" class="collapse" role="tabpanel" aria-labelledby="filtersHeading">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <form @submit.prevent="onSubmit" autocomplete="off">
                        <div v-if="contextType !== 'promoted' && contextType !== 'duplicated' && contextStatus !== contextPostClassStatusExpired">
                          <div class="form-row mb-4 mt-4">
                            <div class="col-12"><slot name="expiring-ad"></slot></div>
                            <div class="col">
                              <select v-model="query.expiringAd" class="browser-default custom-select">
                                <option selected value><slot name="all"></slot></option>
                                <option value="1"><slot name="yes"></slot></option>
                                <option value="2"><slot name="no"></slot></option>
                              </select>
                            </div>
                          </div>

                        <div class="form-row mb-4">
                          <div class="col-12"><slot name="expired-promo"></slot></div>
                          <div class="col">
                            <select v-model="query.expiredPromo" class="browser-default custom-select">
                              <option selected value><slot name="all"></slot></option>
                              <option value="1"><slot name="yes"></slot></option>
                              <option value="2"><slot name="no"></slot></option>
                            </select>
                          </div>
                        </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col">
                        <input type="text" class="form-control" v-model.trim="query.q" :placeholder="searchPlaceholder" autocomplete="off" v-on:input="query.q = $event.target.value.toLowerCase()" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col">
                        <select v-model="query.category" class="browser-default custom-select" autocomplete="off">
                          <option selected value><slot name="category"></slot></option>
                          <option v-for="option in categoriesFiltered" :key="option.pk" :value="option.pk">{{option.name}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col">
                        <select v-model="query.city" class="browser-default custom-select" autocomplete="off">
                          <option selected value><slot name="city"></slot></option>
                          <option v-for="option in cities" :key="option.pk" :value="option.pk">{{option.name}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <select id="emailSelect" v-model="query.email" class="browser-default custom-select">
                                <option selected value><slot name="email"></slot></option>
                                <option v-for="contact in contacts" :key="contact.pk" :value="contact.pk" v-if="contact.contact_type == 2">{{contact.contact}}</option>
                            </select>
                        </div>
                    </div>

                    <ui-button
                        @click="onSubmit"
                        appearance="secondary"
                        :label="i18n.submitButton"
                        uppercase
                    />
                 </form>
                </div>
            </div>
        </div>
      </div>

    </div>
        <!-- end of filters -->
    </div>

</template>

<script>
    import Url from "domurl";

    export default {
        components: {
            ProfileSelect: () => import(/* webpackChunkName: "chunk-profile-select" */ './profile-select.vue'),
            UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
        },
        props: {
            initType: { type: String, default: "" },
            searchPlaceholder: String,
            isMultiProfile: Boolean,
            initLanguageCode: String,
            initProfile: { type: String, default: "" },
            contextStatus: { type: String, default: "" },
            contextPostClassStatusExpired: { type: String, default: "" },
            contextType: { type: String, default: "" },
            initProfileId: String,
            profiles: {
                type: Array,
                default: () => [],
            },
            contacts: {
                type: Array,
                default: () => [],
            },
        },
        data(){
               return  {
                    // Where is defined locations?
                    categories: locations.getCategories(this.initLanguageCode),
                    cities: locations.getCities(),
                    query: {
                        "q": "",
                        "type": this.initType,
                        "city":"",
                        "category":"",
                        "email":"",
                        "expiredPromo": "",
                        "expiringAd":"",
                        "profile": this.initProfile,
                   },
                   filters:0,
                   i18n: {
                        profileSelectLabel: gettext("Search by profile"),
                        profileSelectPlaceholder: gettext("All"),
                        submitButton: gettext("Filter"),
                        modalTitle: gettext("Select a profile"),
                    }

            };
        },
        computed: {
         categoriesFiltered: function() {
           return this.categories.filter(function(c) {
             return !c.is_macro;
                })
            }
        },
        watch: {
            'query.type': function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.handleQueryUpdate(this.initProfileId);
                }
            }
        },
        mounted: function(){
            this.categories = locations.getCategories(this.initLanguageCode) || []; // Avoid undefined
            this.cities = locations.getCities() || [];
            var url = new Url();
            if(locations.language_prefix && url.path.lastIndexOf(locations.language_prefix+'/', 0) !== 0){
                    url.path = locations.language_prefix + url.path;
            }
            for(let key in this.query){
                if(url.query[key]){
                    if (key !== "type" && key !== "profile") this.filters += 1;
                    this.query[key]=url.query[key];
                }
            }
        },
        methods: {
            clearAll: function(event){
                var url = new Url();
                for(let key in this.query){
                  if(url.query[key]){
                    if(key!=='type')this.query[key]='';
                    if(key!=='profile')this.query[key]='';
                    this.onSubmit()
                  }
                }
            },
            handleQueryUpdate: function(profileId){
                if(profileId){
                    this.query.profile = profileId;
                }else{
                  this.query.profile = '';
                }
                this.updateUrl();
            },
            onSubmit: function(event){
              this.updateUrl();
            },
            updateUrl:function() {
              const url = new Url(window.location.href);
              url.clearQuery();
              Object.keys(this.query).forEach((key) => {
                if(this.query[key]){
                  if(key==='category'){
                      url.query[key] = this.query.category ? locations.getCategoryByPk(this.query.category).pk : null;
                  }
                  else if(key==='city'){
                      url.query[key] = this.query.city ? locations.getCityByPk(this.query.city).pk : null;
                  }else{
                      url.query[key]=this.query[key]
                  }
                }
              });
              if (window.location.href !== url.toString()) window.location = url;
            },
        },
    };
</script>
